"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["src"];
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoundIcon',
    props: {
        src: {},
        active: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["the-round-icon", { active: props.active }])
            }, [
                (0, vue_2.renderSlot)(_ctx.$slots, "default", {}, () => [
                    (0, vue_2.createElementVNode)("img", {
                        src: __props.src,
                        draggable: "false"
                    }, null, 8, _hoisted_1)
                ])
            ], 2));
        };
    }
});
